import React from 'react'

const InputPrefix = ({prefix, defaultValue, removable, onRemove, prefixStyle = {}, ...props}) => {
  const handleDelete = () => {
    if(typeof onRemove === 'function'){
      onRemove()
    }
  }

  return (
    <div className="flex items-center">
      <div className={`${removable ? 'mr-4' : ''} w-full`}>
        <div className={`w-full rounded border py-2 px-4 text-sm`} style={{borderColor: '#ddd'}}>
          <div className="flex">
            {
              prefix && <div className="text-gray-999" style={prefixStyle}>{prefix}</div>
            }
            <input defaultValue={defaultValue} className="block w-full" {...props}/>
          </div>
        </div>
      </div>
      {
        removable &&
        <p className="w-auto text-xs text-gray-999 underline cursor-pointer" onClick={handleDelete}>Delete</p>
      }
    </div>
  )
}

export { InputPrefix }
